<template>
  <div class="developer">
    <div class="part-1"></div>

    <div class="part-2">
      <div class="main">
        <p class="tit">{{ $t("team.part3.head") }}</p>

        <div class="items">
          <div class="item">
            <p class="name">{{ $t("team.part3.title1") }}</p>
            <div class="txt">{{ $t("team.part3.description1") }}</div>
          </div>

          <div class="item">
            <p class="name">{{ $t("team.part3.title2") }}</p>
            <div class="txt">{{ $t("team.part3.description2") }}</div>
          </div>

          <div class="item">
            <p class="name">{{ $t("team.part3.title3") }}</p>
            <div class="txt">{{ $t("team.part3.description3") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CarouselItem, Carousel } from "iview";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "team",
  components: {},
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
@import url("../assets/css/var.less");
.developer {
  .part-1 {
    height: 720px;
    background-image: url("../assets/images/team-bg.png");
    @media screen and (max-width: 1400) {
      background-image: url("../assets/images/team-bg-sm.png");
    }
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 100%;
    overflow: hidden;
  }

  .part-2 {
    background-color: #fff;
    .main {
      max-width: 1200px;
      padding: 0;
      overflow: hidden;
      height: 100%;
    }
    .tit {
      .part-tit();
      margin-top: 63px;
      font-size: 27px;
      font-weight: 600;
      color: #315dd2;
      line-height: 1.2;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 294px;
        height: 13px;
        background-color: rgba(49, 93, 210, 0.14);
      }
    }
    .items {
      margin-top: 60px;
      margin-bottom: 80px;
      display: flex;
      justify-content: space-around;
      .item {
        box-sizing: border-box;
        width: 380px;
        height: 704px;
        border-radius: 4px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        margin: 0 10px;
        padding: 36px 30px 20px;
        background-repeat: no-repeat;
        background-size: cover;
        .name {
          font-size: 22px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 1;
          margin-bottom: 10px;
        }

        .txt {
          font-weight: 400;
          font-size: 15px;
          color: #999999;
          line-height: 24px;
          hyphens: auto;
          text-align: justify;
          transition:all 0.5s;
        }

        &:nth-child(1) {
          background-image: url("../assets/images/team-part-bg1.png");
        }
        &:nth-child(2) {
          background-image: url("../assets/images/team-part-bg1.png");
        }
        &:nth-child(3) {
          background-image: url("../assets/images/team-part-bg3.png");
        }
        &:hover {
          background-image: url("../assets/images/team-part-bg2.png");
          .name {
            color: #fff;
          }
          .txt {
            color: #fff;
          }
        }
      }
    }
  }
}
/deep/.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("../assets/images/team/jiantou-you.png");
  background-size: 44px 44px;
  background-repeat: no-repeat;
}
/deep/.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("../assets/images/team/jiantou-zuo.png");
  background-size: 44px 44px;
  background-repeat: no-repeat;
}
/deep/.swiper-button-prev,
.swiper-button-next {
  width: 44px;
}
/deep/.ivu-carousel {
  height: 100%;
}
/deep/.ivu-carousel-dots-inside {
  bottom: 100px;
}
/deep/.ivu-carousel-arrow {
  top: 38%;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: #eaeaea;
}
</style>
